// extracted by mini-css-extract-plugin
export default {"adminCardContainer":"AdminCard_adminCardContainer__MXmxE","adminCard":"AdminCard_adminCard__uS5HL"};